import React from 'react';

export const inputClass =
    'w-full rounded-lg border border-gray-300 bg-white p-3 text-textColor focus:outline-none focus:ring-2 focus:ring-lineGreen';

export const SHORT_MAX_LENGTH = 200;

export const TEXT_MAX_LENGTH = 5000;

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const SEND_FAILED_TEXT =
    'Deine Nachricht konnte gerade nicht gesendet werden. Bitte versuche es erneut oder schreib uns auf WhatsApp.';

export const REQUIRED_TEXT = 'Bitte fülle dieses Feld aus.';

export const EMAIL_INVALID_TEXT = 'Bitte prüfe die eingegebene E-Mail-Adresse.';

interface FormFieldProps {
    label: string;
    htmlFor: string;
    required?: boolean;
    error?: string;
    children: React.ReactNode;
}

const FormField: React.FC<FormFieldProps> = ({ label, htmlFor, required = false, error, children }) => (
    <div>
        <label htmlFor={htmlFor} className="mb-1 block font-semibold text-textColor">
            {label}
            {required && <span aria-hidden="true">*</span>}
        </label>
        {children}
        {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
);

export default FormField;

export const SubmitButton: React.FC<{ sending: boolean; children: React.ReactNode }> = ({ sending, children }) => (
    <button
        type="submit"
        disabled={sending}
        className="inline-flex items-center justify-center rounded-full border-2 border-primary bg-primary px-6 py-2.5 font-semibold text-textColor transition hover:border-primaryDark hover:bg-primaryDark disabled:opacity-60"
    >
        {sending ? 'Wird gesendet …' : children}
    </button>
);
